import { render, staticRenderFns } from "./businessOpportunity.vue?vue&type=template&id=20bbcbb8&scoped=true"
import script from "./businessOpportunity.vue?vue&type=script&lang=js"
export * from "./businessOpportunity.vue?vue&type=script&lang=js"
import style0 from "./businessOpportunity.vue?vue&type=style&index=0&id=20bbcbb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20bbcbb8",
  null
  
)

export default component.exports